module.exports = __webpack_public_path__ + "static/media/rocket.40f0ff9d.png";